import React, { useState } from 'react';
import './App.css';
import SoulmateForm from './components/SoulmateForm';
import SoulmateResult from './components/SoulmateResult';

function App() {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleFormSubmit = async (formData) => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
      const response = await fetch(`${apiBaseUrl}/soulmate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Something went wrong');
      }

      const data = await response.json();
      setResult({
        text: data.response,
        imageUrl: data.image_url
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setResult(null);
    setError(null);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>🔮 Soulmate Astrology Reading</h1>
        <p>Discover your cosmic love connection</p>
      </header>

      <main className="App-main">
        {!result && !loading && (
          <SoulmateForm onSubmit={handleFormSubmit} loading={loading} />
        )}

        {loading && (
          <div className="loading">
            <div className="spinner"></div>
            <p>Consulting the stars... This may take a moment.</p>
          </div>
        )}

        {error && (
          <div className="error">
            <h3>⚠️ Error</h3>
            <p>{error}</p>
            <button onClick={handleReset} className="retry-button">
              Try Again
            </button>
          </div>
        )}

        {result && (
          <SoulmateResult 
            result={result.text} 
            imageUrl={result.imageUrl}
            onReset={handleReset} 
          />
        )}
      </main>
    </div>
  );
}

export default App;
